import $ from 'jquery';

const drhDisclaimerPopUpHandler = {
    variables: {
         url: window.location.href,
    },
    methods: {
        hideBackgroundScroll : function(){
        let basePage = document.querySelector(".base-page");
        let drhpComponent = document.querySelector(".drhp_disclaimer--popup");
        if(drhpComponent)
         {basePage.classList.add("basepage-overflow-hidden");}
        },
        ctaButtonClickHandler : function(ele){
          $('.drhp_disclaimer--popup .drhp_disclaimer--popupContainer .drh_disclaimer--btnContainer').on('click','.confirm-btn',function(){
            let buttonText = $(this).text().replace(/\s+/g, ' ').trim().replace(/\s*\(?opens in a new tab\)?\s*/i, '');
            let disclaimerContainer = $(this).closest('.drh_disclaimer--btnContainer').closest('.drhp_disclaimer--popupContainer').closest('.drhp_disclaimer--popup');
            let basePage = document.querySelector(".base-page");
            basePage.classList.remove("basepage-overflow-hidden");
            let obj = drhDisclaimerPopUpHandler.methods.dataLayerObj(buttonText,"Disclaimer-Important");
            createDataLayer('buttonClick',obj);
            disclaimerContainer.addClass("d-none");
          });
        },
        ctaNotConfirmButtonClickHandler : function(ele){
          $('.drhp_disclaimer--popup .drhp_disclaimer--popupContainer .drh_disclaimer--btnContainer').on('click','.not_confirm-btn',function(){
            let buttonText = $(this).text().replace(/\s+/g, ' ').trim().replace(/\s*\(?opens in a new tab\)?\s*/i, '');
            let disclaimerContainer = $(this).closest('.drh_disclaimer--btnContainer').closest('.drhp_disclaimer--popupContainer');
            let obj = drhDisclaimerPopUpHandler.methods.dataLayerObj(buttonText,"Disclaimer-Important");
            createDataLayer('buttonClick',obj);
            let actionLink = disclaimerContainer.data('notconfirmactionlink');
            if (!actionLink || actionLink.trim() === "") {
              console.warn("No valid link found in data attribute, defaulting to /homepage.");
              actionLink = "/homepage";
            }
            const userConfirmed = window.confirm("You are not permitted to view this section of the website");
            if(userConfirmed) {
             window.location.href = actionLink;
            } else {
             window.location.reload();
            }
          });
        },
        dataLayerObj : function(e,el) {
            var obj = {
                'articleName' : "",
                'blogCategory' : "",
                'blogPageCategory' : "",
                'buttonText' : e ? e : "",
                'pageSection' : el ? el : "",
                'pageType' : document.querySelector("meta[name='template']").content == 'chli-base-page-template' ? drhDisclaimerPopUpHandler.variables.url.includes("blog") ? "Blogs" : drhDisclaimerPopUpHandler.variables.url.substring(drhDisclaimerPopUpHandler.variables.url.indexOf(".com/"), drhDisclaimerPopUpHandler.variables.url.lastIndexOf('/')  === ".com") && !drhDisclaimerPopUpHandler.variables.url.substring(drhDisclaimerPopUpHandler.variables.url.indexOf(".com/"), drhDisclaimerPopUpHandler.variables.url.length-1).includes('/') ? "Home" : "Other Pages" : "Blog Details Page",
                'planOption' : "",
                'productCategory' : "",
                'productName' : "",
                'question' : "",
                'searchTerm' : "",
                'videoTitle' : "",
                'bannerName' : "",
                'bannerType' : ""
            };
           return obj;
        }
    }
};

$(() => {
    drhDisclaimerPopUpHandler.methods.hideBackgroundScroll();
});

$(function () {
  drhDisclaimerPopUpHandler.methods.ctaButtonClickHandler();
  drhDisclaimerPopUpHandler.methods.ctaNotConfirmButtonClickHandler();
});
